<template>
  <div class="router-transitions">
    <div class="container">
      <TitleCustom v-if="$cookie.get('language') == 'fr'" blackTitle="Gestion des" blueTitle="Cookies"></TitleCustom>
      <TitleCustom v-else blackTitle="Cookies" blueTitle="Management"></TitleCustom>
      <b-card v-if="$cookie.get('language') == 'fr'">
        <p>
          Les cookies sont des petits fichiers textes déposés sur votre appareil pour stocker des données. Le site utilise les cookies suivants :
          <ul>
            <li>Cookies techniques : cookies nécessaires (autorisés par la loi). Ils ont pour but la protection du site, l’équilibrage de charge, la gestion de la connexion, la gestion du panier, etc.
              Le site ne peut pas fonctionner sans eux.</li>
            <li>
              Cookies de personnalisation : ils permettent d’adapter le site à vos besoins et vos désidératas.
            </li>
            <li>
              Cookies d’outils tiers : ils permettent de proposer sur le site des fonctionnalités particulières (cartes, outils de partage, etc).
            </li>
            <li>
              Cookies statistiques : ils permettent d’analyser votre navigation et nous permettent de mesurer l’audience du site internet.
            </li>
        </ul>
        </p>
        <b-btn variant="default"  @click="$router.go(-1)">{{ $t('back') }}</b-btn>
      </b-card>
      <b-card v-else>
        <p>Cookies are small text files placed on your device to store data. The website uses the following cookies:</p>
        <ul>
          <li>Technical cookies: necessary cookies (authorized by law). Their purposes are: website protection, load balancing, connection management, shopping cart management, etc.
            The website cannot function without them.</li>
          <li>Personalization cookies: they allow the website to be adapted to your needs and wishes.</li>
          <li>Third-party tool cookies: they make it possible to offer specific functionalities on the site (maps, sharing tools, etc.).</li>
          <li>Statistical cookies: they allow you to analyze your browsing and allow us to measure the audience of the website.</li>
        </ul>
        
  
      </b-card>
    </div>
  </div>
</template>

<script>
  import TitleCustom from '../components/title'
  export default {
    name: 'Confidentialite',
    components: { TitleCustom, },
    mounted() {
      if (this.$cookie.get('language') === 'fr' || this.$cookie.get('language') === 'en'){
        this.$i18n.locale = this.$cookie.get('language')
      } else {
        this.$cookie.set('language', 'fr', 300);
        location.reload();
      }
    
    },

  }
</script>
